import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function ConfirmationModal({
  title,
  description,
  isOpen,
  onClose,
  onConfirm,
  variant = "normal", // 'normal' | 'green' | 'danger'
  maxWidth = "max-w-md",
}) {
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) {
      setDisable(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  // Define variant styles
  const variants = {
    normal: {
      titleColor: "text-yellow-400",
      buttonColor: "bg-yellow-400 hover:bg-yellow-300 text-black",
    },
    green: {
      titleColor: "text-green-400",
      buttonColor: "bg-green-500 hover:bg-green-400 text-white",
    },
    danger: {
      titleColor: "text-red-400",
      buttonColor: "bg-red-500 hover:bg-red-400 text-white",
    },
  };

  const handleDisable = () => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
  };

  const current = variants[variant] || variants.normal;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center px-4">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className={`bg-white/10 border border-white/10 shadow-xl rounded-2xl ${maxWidth} w-full p-6 text-white animate-fade-in`}
      >
        <h2
          className={`text-xl font-bold text-center mb-4 ${current.titleColor}`}
        >
          {title}
        </h2>
        <div className="text-sm text-center text-white/80 mb-6">{description}</div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={() => {
              handleDisable();
              onConfirm();
            }}
            disabled={disable}
            className={`font-semibold px-4 py-2 rounded-md transition ${current.buttonColor} ${disable ? 'bg-gray-500/30 border-gray-500 cursor-not-allowed' : ''}`}
          >
            Yes
          </button>
          <button
            onClick={onClose}
            className="bg-white/10 border border-white/20 text-white px-4 py-2 rounded-md hover:bg-white/20 transition"
          >
            No
          </button>
        </div>
      </motion.div>
    </div>
  );
}
